import React from 'react';

export class FileInput extends React.Component
    <{
        caption: string,
        accept: '.xlsx' | '.jpg, .jpeg' | '.svg',
        name: string,
        onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
    },
    {
        filename: string | null,
    }> {

    state = { filename: null };

    onChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const filePath = e.currentTarget.value;
        if (filePath) {
            this.setState({ filename: filePath.split(/[\\\/]/).pop() || filePath });
        } else {
            this.setState({ filename: null });
        }
        this.props.onChange && this.props.onChange(e);
    }

    render() {
        return <label className="linkbutton">
                   {this.state.filename || this.props.caption}
                   <input name="{this.props.name}" type="file" accept={this.props.accept} className="import__fileinput"
                          onChange={this.onChange.bind(this)}/>
               </label>
            ;
    }
}